const esImg = {};
const ptImg = {};
const enImg = {};
const cnImg = {};

const imgMap = {
  // "--p1-pc-anchor": "pc/p1/anchor.png",
  // "--p1-pc-cover": "pc/p1/cover.png",
};
// 为所有语言生成图片映射
const languages = {
  cn: cnImg,
  en: enImg,
  es: esImg,
  pt: ptImg,
  "zh-TW": cnImg, // 繁体中文使用cn目录
  th: {}, // 泰文
};

const langKeys = Object.keys(languages) as (keyof typeof languages)[];

// 为其他语言生成映射
Object.keys(imgMap).forEach((key) => {
  langKeys.forEach((lang) => {
    const langObj = languages[lang];
    langObj[key] = `url('${
      new URL(`../assets/images/${lang}/${imgMap[key]}`, import.meta.url).href
    }')`;
  });
});

// zh-TW使用cn的映射
languages["zh-TW"] = languages.cn;

// 设置CSS变量的函数
export const setLangImages = (lang: string) => {
  const langImages = languages[lang] || languages["zh-TW"];
  Object.keys(langImages).forEach((key) => {
    document.documentElement.style.setProperty(key, langImages[key]);
  });
};

// 获取img标签src的函数
export const getImageSrc = (lang: string, imagePath: string) => {
  try {
    return new URL(`../assets/images/${lang}/${imagePath}`, import.meta.url)
      .href;
  } catch (error) {
    console.warn(`Failed to load image for ${lang}/${imagePath}:`, error);
    // 回退到默认语言
    try {
      return new URL(`../assets/images/zh-TW/${imagePath}`, import.meta.url)
        .href;
    } catch (fallbackError) {
      console.error("Failed to load fallback image:", fallbackError);
      return "";
    }
  }
};

// 批量获取多个图片src的函数
export const getImagesSrc = (lang: string, imagePaths: string[]) => {
  return imagePaths.reduce((acc, path) => {
    const key = path.replace(/\//g, "_").replace(/\./g, "_"); // 将路径转换为合法的key
    acc[key] = getImageSrc(lang, path);
    return acc;
  }, {} as Record<string, string>);
};

export { enImg, ptImg, esImg, cnImg };
